import { Box, InputLabel, ListItem, Stack, Typography } from '@mui/material';
import { ITreatmentOrderDTO } from 'API/Treatment/treatment';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useEffect, useState } from 'react';
import { ControlledSelectInput2, NoResults2 } from 'Components';
import { OrderCard } from '../OrderCard';
import { NoRecentOrdersFound } from './NoRecentOrdersFound';

interface IRecentOrdersSection {
  data?: ITreatmentOrderDTO[];
}

export const RecentOrdersSection = ({ data }: IRecentOrdersSection) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Treatment);
  const isDesktop = useIsDesktop();
  const currentYear = new Date().getFullYear().toString();

  const [filterOrders, setFilterOrders] = useState<ITreatmentOrderDTO[]>();
  const [filterByYear, setFilterByYear] = useState(currentYear);
  const listOfYears = data
    ? [
        currentYear,
        ...data
          .sort((a, b) => (b?.entitledYear ?? 0) - (a?.entitledYear ?? 0))
          .map((item) => item?.entitledYear?.toString())
          .filter(
            (year, index, self) =>
              year !== currentYear && self.indexOf(year) === index
          ),
      ]
    : [currentYear];

  useEffect(() => {
    setFilterOrders(data);
  }, [data]);

  useEffect(() => {
    let ordersFilteredArray = data;

    if (ordersFilteredArray) {
      ordersFilteredArray = ordersFilteredArray.filter(
        (item) => item?.entitledYear?.toString() === filterByYear
      );
    }

    setFilterOrders(ordersFilteredArray);
  }, [filterByYear, data]);

  return (
    <Stack gap={'32px'}>
      <Stack gap={'24px'}>
        <Typography component='h2' variant={'h5'} color={'text.secondary'}>
          {dictionary.recentOrders.title}
        </Typography>

        <Stack
          flexDirection={'row'}
          maxWidth={'240px'}
          height={'48px'}
          alignItems={'center'}
          gap={'20px'}
        >
          <InputLabel
            id={'select-year-label'}
            htmlFor='select-year'
            sx={{
              gap: ' 10px',
              display: 'flex',
              padding: '5px',
              alignItems: 'center',
            }}
          >
            <Typography variant={'body2'}>
              {dictionary.recentOrders.labelFilter}
            </Typography>
            <Box
              position={'relative'}
              width={isDesktop ? '158px' : '114px'}
              height={isDesktop ? '48px' : '43px'}
              top={isDesktop ? '3px' : 0}
            >
              <ControlledSelectInput2
                id={'select-year'}
                size={'small'}
                onChange={(e) => setFilterByYear(e.target.value)}
                value={filterByYear?.toString() ?? ''}
                ariaLabelledById='select-year-label'
                options={listOfYears.map((y) => y?.toString() ?? '')}
                sx={{ pt: '3px' }}
              />
            </Box>
          </InputLabel>
        </Stack>
      </Stack>
      {filterOrders && filterOrders.length > 0 ? (
        <Stack
          component={'ul'}
          gap={isDesktop ? '24px' : '20px'}
          sx={{ margin: 0, padding: 0 }}
        >
          {filterOrders.map((order: ITreatmentOrderDTO, index) => (
            <ListItem key={index} sx={{ padding: 0 }}>
              <OrderCard order={order} />
            </ListItem>
          ))}
        </Stack>
      ) : (
        <NoRecentOrdersFound />
      )}
    </Stack>
  );
};
